<template>
    <el-select id="rmaStatusSelectorInput" :value="value" class="select" :placeholder="$t('shared.pleaseSelectStatus')" v-bind:disabled="disabled" @change="$emit('input', $event)">
        <el-option v-if="value == 0 || value == 2" v-for="item in reOpenStatuses" :key="item.id" :label="item.name" :value="item.id"></el-option>
        <el-option v-if="value == 1" v-for="item in statuses" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
</template>

<script>
    export default {
        name: 'rma-status-selector',
        props: ['value', 'disabled'],
        data() {
            return {
                loading: false,
                statuses: [{ id: 0, name: "Closed" }, { id: 1, name: "Opened" }],
                reOpenStatuses: [{ id: 0, name: "Closed" }, { id: 2, name: "Reopen" }]
            }
        }
    }
</script>

<style scoped>
    .select {
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// ClientApp/app/shared/components/RmaStatusSelector.vue